<template>
    <div class='tep-officials-wrap'>
        <dx-button hint="Связь с долж.лицами" width='32px' height='32px' @click="openPopup">
            <img :src="'/infoenergo/assets/tep/tep-cards/phone.svg'" alt='' class='w-full h-full'>
        </dx-button>

        <dx-popup
            ref="popupRef"
            height="75%"
            title="Связь с должностными лицами организации"
            :drag-enabled="true"
            :hide-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :visible="popupVisible"
            @hiding='onPopupHiding'
        >
            <div class='dx-field'>
                <div class='dx-field-label' style='width: fit-content'>Владелец: </div>
                <ai-text-box-readonly :value='orgNameValue' class='dx-field-value' style='flex: 1' />
            </div>
            <ai-grid-edit ref="gridRef"
                :args="gridArgs"
                :meta="gridMeta"
                :to-remove-toolbar-items-names='["edit", "choice", "export", "settings", "show-column-chooser"]'
            />
        </dx-popup>
    </div>
</template>

<script>
export default {
    name: 'tep-officials-button',
};
</script>

<script setup>
import { DxButton, DxPopup } from 'devextreme-vue';
import { inject, ref } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';
import tepService from '@/service/tep-service';
import { dxUiNotify } from '@/utils/dx-helper';
import { getCookie } from '@/utils/cookies';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    }
});

const userData = inject('userData');

const gridDefaultMeta = {
    "keyExpr": "kod_emp",
    "columns": [
        {
            "name": "kodp",
            "caption": "Подразделение",
            "dataField": "kodp",
            "allowEditing": false,
            "editor": {
                "type": "default"
            },
            "width": 0,
            "index": 0,
            "visible": false
        },
        {
            "name": "kod_emp",
            "caption": "Код",
            "dataField": "kod_emp",
            "allowEditing": false,
            "editor": {
                "type": "default"
            },
            "width": 0,
            "index": 1,
            "visible": false
        },
        {
            "name": "kod_namedolzh",
            "dataField": 'kod_namedolzh',
            "caption": 'Должность',
            "allowEditing": true,
            "width": 200,
            "editor": { "type": 'ai-drop-down', "text": 'name_dolzh' },
            "component": {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text: 'name',
                meta: {
                    keyExpr: 'kod',
                    columns: [{caption: 'kod', visible: false, dataField: 'kod'}, {caption: 'Должность', dataField: 'name'}],
                    api: {select: 'meta./meta/ai-grid-ro/select/get'},
                },
                args: {meta_args: {select: 'tep_grid.q_card_f_namedolzh_sel'}, select_args: {}},
            },
            "index": 2,
            "visible": true
        },
        {
            "name": "kod_dolzhfun",
            "caption": "Должностная функция",
            "dataField": "kod_dolzhfun",
            "allowEditing": true,
            "width": 200,
            "editor": { "type": 'ai-drop-down', "text": 'name_dolzhfun' },
            "component": {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text: 'name',
                meta: {
                    keyExpr: 'kod',
                    columns: [{caption: 'kod', visible: false, dataField: 'kod'}, {caption: 'Должностная функция', dataField: 'name'}],
                    api: {select: 'meta./meta/ai-grid-ro/select/get'},
                },
                args: {meta_args: {select: 'tep_grid.q_card_f_dolzhfun_sel'}, select_args: {}},
            },
            "index": 3,
            "visible": true
        },
        {
            "name": "fio",
            "caption": "Ф.И.О.",
            "dataField": "fio",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 300,
            "index": 4,
            "visible": true
        },
        {
            "name": "tel",
            "caption": "Телефон",
            "dataField": "tel",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 5,
            "visible": true
        },
        {
            "name": "fax",
            "caption": "Факс",
            "dataField": "fax",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 6,
            "visible": true
        },
        {
            "name": "remark",
            "caption": "Примечание",
            "dataField": "remark",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 7,
            "visible": true
        },
        {
            "name": "place",
            "caption": "Местонахождение",
            "dataField": "place",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 8,
            "visible": true
        },
        {
            "name": "serial",
            "caption": "Серия паспорта",
            "dataField": "serial",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 9,
            "visible": true
        },
        {
            "name": "nomer",
            "caption": "Номер паспорта",
            "dataField": "nomer",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 10,
            "visible": true
        },
        {
            "name": "kem",
            "caption": "Кем выдан паспорт",
            "dataField": "kem",
            "allowEditing": true,
            "editor": {
                "type": "default"
            },
            "width": 200,
            "index": 11,
            "visible": true
        }
    ],
    "api": {
        "select": "tep_grid./tep/org-employee-select/get",
        "save": "tep_grid./tep/org-employee-save/set"
    },
    "viewId": "tep-org-employee-view"
}

const commonArgs = {
    depId: +getCookie('dep'),
    login: getCookie('login')
}
const defaultGridArgs = {
    select: {
        select_args: {...commonArgs}
    },
    save: {
        update_args: {...commonArgs},
        insert_args: {...commonArgs},
        delete_args: {...commonArgs}
    }
};

const orgKod = ref(null);
const orgNameValue = ref('');
const popupRef = ref();
const popupVisible = ref(false);
const gridRef = ref();
const gridArgs = ref(defaultGridArgs);
const gridMeta = ref(gridDefaultMeta);

const openPopup = async () => {
    orgKod.value = userData.value[props.meta.fieldKodOrg];
    if (!orgKod.value) {
        dxUiNotify('Не выбрана организация для просмотра должностных лиц', 'warning', 3000);
    } else {
        const newGridArgs = {...defaultGridArgs};
        newGridArgs.select.select_args.kodp = orgKod.value;
        newGridArgs.save.update_args.kodp = orgKod.value;
        newGridArgs.save.insert_args.kodp = orgKod.value;
        newGridArgs.save.delete_args.kodp = orgKod.value;
        gridArgs.value = newGridArgs;
        const newGridMeta = {...gridDefaultMeta};
        newGridMeta.columns.forEach(item => {
            if ([2, 3].includes(item.index)) {
                item.component.args.select_args.kodp = orgKod.value;
            }
        })
        gridMeta.value = newGridMeta;
        await gridRef.value?.setDataSource();
        orgNameValue.value = await tepService.getOrgEmployeeName(orgKod.value);
        popupVisible.value = true;
    }
}

const onPopupHiding = async (e) => {
    if (popupVisible.value) {
        e.cancel = true;
        const canClose = await gridRef.value?.checkBeforeClose();
        if (canClose) {
            popupRef.value?.instance.hide();
            popupVisible.value = false;
        }
    }
}
</script>

<style scoped>
.tep-officials-wrap {
    display: flex;
    align-items: center;
    width: max-content;
    padding-top: 10px;
}
</style>
